<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid">
      <!-- Préférences de communication -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Préférences de communication</legend>
        <!-- Question 1 communications promotionnelles -->
        <div>
          <p class="mentionLegal">
            En plus des communications essentielles, j'accepte de recevoir les communications en provenance de l'Ordre (par exemple : les Infolettres,
            les messages destinés aux membres...)
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsPromotionnelles"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 2 information concernant la Revue Intervention -->
        <div>
          <p class="mentionLegal">
            J'accepte de recevoir de l'information concernant la Revue Intervention (parution de nouveaux numéros, appel à contributions...)
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.acceptationInformationRevueIntervention"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsRevueIntervention"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 3 revue scientifique et professionnelle -->
        <div>
          <p class="mentionLegal">
            J'accepte de m'abonner à la revue scientifique et professionnelle publiée mensuellement par l'OTSTCFQ
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.acceptationAbonnementRevueScientifique"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesTypesMandatsBottin"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 4 communications promotionnelles partenaires -->
        <div>
          <p class="mentionLegal">
            J'accepte de recevoir les communications promotionnelles transmises par l'Ordre pour le compte de partenaires (offres de formation, offres
            d'emploi, services, etc.).
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsPromotionnellesPartenaires"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 5 communique mes renseignements professionnels -->
        <div>
          <p class="mentionLegal">
            J'accepte que l'Ordre communique mes renseignements professionnels à caractère public à une personne ou à une organisation qui souhaite
            utiliser ces renseignements à des fins d'étude, de recherche ou de production de statistiques.
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsRenseignementsProfessionnels"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Informations ententes commerciales -->
        <div>
          <p class="mentionLegal">
            J'accepte que l'Ordre communique mes nom, adresse, numéro de téléphone et adresse courriel aux organisations suivantes avec lesquelles il
            a conclu des ententes commerciales à l'intention de ses membres :
          </p>
        </div>
        <!-- Question 6 Assurance personnelle -->
        <div class="ml-8">
          <p class="mentionLegal">
            - Assurance La Personnelle et ses tiers fournisseurs de services (afin de vous faire parvenir de l'information sur ses produits d'assurance 
              et sur le tarif préférentiel d'assurance groupe négocié par l'Ordre pour l'assurance automobile 
              et habitation ou sur tout autre élément de son programme d’assurance).
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.assuranceLaPersonnelle"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesTypesMandatsBottin"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
      </fieldset>

      <!-- Contribuer au développement ou à l'évolution de la profession -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Contribuer au développement ou à l'évolution de la profession</legend>
        <section>
          <p>
            Les référentiels de compétences des professions de T.S. et des T.C.F. précisent que les membres doivent être
            capables de contribuer au développement ou à l'évolution de leur profession. Parmi les occasions suivantes,
            veuillez indiquer celles que vous aimeriez saisir. En cochant une ou plusieurs réponses, vous acceptez que
            l'Ordre communique avec vous pour vous fournir de l'information sur des occasions de contribuer ou pour
            obtenir, le cas échéant, des précisions sur vos qualifications et votre disponibilité.
          </p>
          <div class="legalSection">
            <v-list flat subheader>
              <v-list-item-group>
                <list-item-with-checkbox
                  v-for="fd in contributions"
                  v-bind:key="fd.id"
                  :value="fd.value"
                  :texte="fd.lang00"
                  :disabled="fd.disabled"
                  :property-name="fd.id.toString()"
                  @updateChoix="updateChoix"
                />
              </v-list-item-group>
            </v-list>
<!--            permet de rendre la saisie obligatoire-->
<!--            <v-input :value="this.contributions.filter((ar) => ar.value)" :rules="rules.contributionsCompletion"></v-input>-->
          </div>
        </section>
      </fieldset>

      <!-- Tableau de l'ordre -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Tableau de l'ordre</legend>
        <section>
          <RessourceInfoBulle code="RE-TR-1" />

          <p>
            <RessourceInfoBulle code="RE-TR-2" />
            <v-checkbox
              v-model="transmissionOrdre.nePasDivulguerMesCoordonnees"
              color="primary"
              hide-details
              @change="nePasDivulguerMesCoordonneesChange"
            >
              <template v-slot:label>
                <span class="ml-5">
                  Oui, c'est mon cas. Je demande à l'Ordre de ne pas divulguer mon adresse, mon numéro de téléphone et mon courriel.
                </span>
              </template>
            </v-checkbox>
            <v-autocomplete
              v-if="transmissionOrdre.nePasDivulguerMesCoordonnees"
              v-model="transmissionOrdre.raison"
              :item-text="itemText"
              :item-value="itemValue"
              :items="listesRaisons"
              :rules="rules.raison"
              class="cssRequired"
              label="Raison"
              required
              return-object
              @change="raisonChange"
            ></v-autocomplete>
            <v-text-field
              v-if="transmissionOrdre.nePasDivulguerMesCoordonnees && isRaisonAutre"
              v-model="transmissionOrdre.precision"
              :class="isRaisonAutre && 'cssRequired'"
              :rules="rules.precision"
              label="Précision"
              required
            ></v-text-field>
          </p>
          <p>L'Ordre révisera votre demande et communiquera avec vous au besoin.</p>
        </section>
      </fieldset>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import NavigationPageFormulaireInscriptionMixin from "@/mixins/navigationPageFormulaireInscriptionMixin"
import ListItemWithCheckbox from "@/components/common/ListItemWithCheckbox.vue";

export default {
  mixins: [NavigationPageFormulaireInscriptionMixin],
  props: {
    routeName: {
      type: String,
      default: ""
    }
  },
  components: {
    ListItemWithCheckbox,
    Loader: Loader
  },
  data() {
    return {
      messageSelector: "",
      overlay: false,
      valid: false,
      contributions: [],
      rules: {
        requis: [(v) => !!v || "Cette valeur est requise"],
        raison: [(v) => (this.transmissionOrdre.nePasDivulguerMesCoordonnees && !!v) || "Cette valeur est requise"],
        precision: [(v) => (this.transmissionOrdre.nePasDivulguerMesCoordonnees && this.isRaisonAutre && !!v) || "Cette valeur est requise"],
        contributionsCompletion: [
          () => this.contributions.filter((ar) => ar.value).length > 0 || "Vous devez sélectionner au moins une valeur",
        ],
      }
    }
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      transmissionOrdre: "TransmissionOrdre/GET_TRANSMISSIONORDRE",
      listesCommunicationsTiers: "Catalogue/GET_COMMUNICATIONSTIERS",
      listesTypesMandatsBottin: "Catalogue/GET_TYPESMANDATSBOTTIN",
      listesRaisons: "Catalogue/GET_RAISONS",
      listeContributions: "Catalogue/GET_CONTRIBUTIONS",
      listesCommunicationsRevueIntervention: "Catalogue/GET_COMMUNICATIONSREVUEINTERVENTION",
    }),
    isRaisonAutre() {
      return this.transmissionOrdre.raison?.id === this.$catalogues.transmissionOrdreRaison.autre
    }
  },
  async created() {
    await this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      updateTransmissionOrdre: "TransmissionOrdre/updateTransmissionOrdre",
      getTransmissionOrdreByDemandeInscriptionId: "TransmissionOrdre/getTransmissionOrdreByDemandeInscriptionId"
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.communicationsTiers),
          this.getCatalogue(this.$cataloguesDesc.communicationsTypesBottin),
          this.getCatalogue(this.$cataloguesDesc.communicationsTiersRaison),
          this.getCatalogue(this.$cataloguesDesc.contribution),
          this.getCatalogue(this.$cataloguesDesc.communicationsRevueIntervention),
        ]

        requests.push(this.getTransmissionOrdreByDemandeInscriptionId(this.demandeInscriptionId))

        await Promise.all(requests)

        // définition des coches en fonction du catalogue et des éléments déjà sélectionnés
        let aucuneCoche = false
        this.listeContributions.forEach((property) => {
          const fd = { ...property }
          fd.value = false

          if (this.transmissionOrdre.contribution.find((ar) => ar.id === fd.id)) {
            fd.value = true

            if (fd.id === this.$catalogues.transmissionOrdreContribution.aucune) {
              aucuneCoche = true
            }
          }

          this.contributions.push(fd)
        })
        this.sanitizeContributions(aucuneCoche)

        this.validateForm(true)
        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    async save() {
      this.validateForm()

      if (this.valid) {
        this.messageSelector = "Save"
        this.overlay = true

        // set contribution from locale state
        this.transmissionOrdre.contribution = this.contributions.filter((fd) => fd.value)

        await this.updateTransmissionOrdre(this.transmissionOrdre)

        this.next()
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form?.validate() || false

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    saveAndContinue() {
      this.save()
    },
    nePasDivulguerMesCoordonneesChange() {
      if (this.transmissionOrdre.nePasDivulguerMesCoordonnees) {
        this.transmissionOrdre.raison = null
        this.validateForm(true)
      }
    },
    raisonChange() {
      if (this.transmissionOrdre.nePasDivulguerMesCoordonnees && this.isRaisonAutre) {
        this.transmissionOrdre.precision = null
        this.validateForm(true)
      }
    },
    updateChoix(payload) {
      const dataId = parseInt(payload.field)
      this.contributions.filter((ar) => ar.id === dataId).forEach((c) => (c.value = payload.choix)) // simplification d'écriture, doit se produire 0 ou 1 fois

      if (dataId === this.$catalogues.transmissionOrdreContribution.aucune) {
        this.sanitizeContributions(payload.choix)
      }
    },
    // assure la cohérence des cases cochées
    sanitizeContributions(aucuneValue) {
      // "aucune" pilote la désactivation des autres cases
      this.contributions
        .filter((ar) => ar.id !== this.$catalogues.transmissionOrdreContribution.aucune)
        .forEach((c) => (c.disabled = aucuneValue))

      // si coché on veux vider les autres coches
      if (aucuneValue === true) {
        this.contributions.filter((ar) => ar.id !== this.$catalogues.transmissionOrdreContribution.aucune).forEach((c) => (c.value = false))
      }
    },
  }
}
</script>

<style></style>